// extracted by mini-css-extract-plugin
export default {"button":"style_button__fcTZQ","buttonwhite":"style_buttonwhite__OWuh0"};